import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import uuid from 'uuid/v1';
import { Button } from 'react-bootstrap';

const PButton = (props) => {
  const position = props.position ? props.position : 'left';
  const type = props.type ? props.type : 'button';
  const loadingClass = props.loading ? 'show-loading' : '';
  const className = `im-button pull-${position} ${loadingClass} ${props.className || ''}`;
  const textLable = _.isEmpty(props.text) ? null : (<span>{props.text}</span>);

  return (
    <Button
      key={uuid()}
      type={type}
      bsStyle={props.bsStyle}
      bsSize={props.bsSize}
      className={className}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {textLable}
      {props.children}
    </Button>
  );
};

PButton.propTypes = {
  position: PropTypes.string,
  bsSize: PropTypes.string,
  bsStyle: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  text: PropTypes.string,
};

export default PButton;



// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/Wrapper/Button.js